<template>
  <div class="w100m">
    <div class="w100 flexVC" v-if="$store.state.isPc">
      <div class="title">趁早用户协议</div>
      <div style="width: 85%;max-width:1200px;margin-bottom: 80px;" class="content" v-html="agreement"></div>
    </div>
    <div class="w100m Bf0f2f5 flexVC" v-if="!$store.state.isPc">
      <div class="title-m">趁早用户协议</div>
      <div style="width: 6.54rem;margin-bottom: 80px;" class="content-m" v-html="agreement"></div>
    </div>
    <shape-footer></shape-footer>
  </div>

</template>

<script>
  import shapeFooter from '@/components/ShapeFooter'
  import {agreement} from '@/utils/staticData'

  export default {
    name: "Agreement",
    data() {
      return {
        cover: 'cover',
        aboutImg: 'https://czcollege.oss-cn-beijing.aliyuncs.com/official-shape/about/%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20201007122129.png',
        content: '通过线上线下内容，以及配套创新型的文创产品、线上陪伴式目标达成工具、支持使用者养成习惯，抵达目标',
        agreement: '',
      }
    },

    components: {
      shapeFooter,
    },

    mounted() {
      window.scrollTo(0, 0);
      this.$store.commit('edit', 4)
      var str = "<p>" + agreement.replace(/\n|\r\n/g, "</p><p>") + "<p>"
      var str2 = "<p>" + agreement.replace(/\n|\r\n/g, "<br/>") + "<p>"
      this.agreement = str2
      console.log(str2)
    }
  }
</script>

<style scoped>

  .title {
    font-size: 32px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.85);
    margin-top: 160px;
    margin-bottom: 80px;
  }

  .title-m{
    font-size: 0.32rem;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.85);
    margin-top: 1.60rem;
    margin-bottom: 0.80rem;
  }

  .content-m{
    font-size: 0.26rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.65);
    line-height: 0.44rem;
  }

  .content {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.85);
    line-height: 32px;
  }

</style>



// WEBPACK FOOTER //
// src/page/about/Agreement.vue